import { render, staticRenderFns } from "./BrewVoteInterface.vue?vue&type=template&id=6372db58&scoped=true"
import script from "./BrewVoteInterface.vue?vue&type=script&lang=js"
export * from "./BrewVoteInterface.vue?vue&type=script&lang=js"
import style0 from "./BrewVoteInterface.vue?vue&type=style&index=0&id=6372db58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6372db58",
  null
  
)

export default component.exports